// src/components/LayoutV2/Logo.jsx
// Shared logo mark — used in both the nav (Header.jsx) and the footer
// (Footer.jsx), so there's one place to change the image URL / fallback
// behavior instead of two. Renders the local logo already shipped in the
// build (public/logo.png — the same asset ShortsRail.jsx uses for the
// video watermark) instead of an external guhso.com fetch, so the nav mark
// doesn't depend on a cross-origin request for a self-hosted asset. The
// onError fallback stays as a safety net in case the asset is ever missing
// from a deploy.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = '/logo.png';

const Logo = ({ className = '' }) => {
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <Link to="/" className={`a-logo ${className}`.trim()} aria-label="Guhso — home">
      {imgFailed ? (
        <span className="a-logo-fallback">Guhso</span>
      ) : (
        <img
          src={LOGO_URL}
          alt="Guhso"
          className="a-logo-img"
          onError={() => setImgFailed(true)}
        />
      )}
    </Link>
  );
};

export default Logo;
